import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'pane', 'form', 'currentTab']

  connect () {
    this.activateSelectedTab();
    this.tabTargets.forEach(tab => { tab.addEventListener("click", this.switchTab.bind(this))})

    requestAnimationFrame(() => {
      if (this.hasFormTarget) {
        let field = this.formTarget.querySelector('.has-error')
        if (field) {
          let hash = '#' + field.closest('.tab-pane').id;
          this.activateTab(hash);
          this.activatePane(hash);
        }
      }
    })
  }

  activateSelectedTab(){
    const hash = window.location.hash

    if (hash && this.tabTargets.some(tab => tab.dataset.hash === hash)) {
      this.activateTab(hash);
      this.activatePane(hash);
    }
  }

  activateTab (hash) {
    const tab = this.tabTargets.find(tab => tab.dataset.hash === hash || tab.dataset.hash === `#${hash}`)
    const value = tab.dataset.value
    requestAnimationFrame(() => {
      const controller = this.application.getControllerForElementAndIdentifier(tab.closest("div"), 'group-button')
      if (controller) { controller.selectedValue = value }
    })
  }

  activatePane (hash) {
    this.paneTargets.forEach(pane => {
      if (pane.id === hash || `#${pane.id}` === hash) {
        pane.classList.remove('hidden')
      } else {
        pane.classList.add('hidden')
      }
    });
  }

  switchTab(event) {
    const tab = event.target.dataset.value;
    this.activateTab(tab);
    this.activatePane(tab);
    this.updateCurrentTab(tab);
  }

  updateCurrentTab(tab) {
    if (this.hasCurrentTabTarget) {
      this.currentTabTarget.value = tab;
    }
  }

  submitForm() {
    if (!this.hasFormTarget) return;
    
    let requiredFieldSelectors = 'input:required, select:required'
    let requiredFields = this.formTarget.querySelectorAll(requiredFieldSelectors)
    let field = Array.from(requiredFields).find(field => !field.disabled && !field.value.trim());

    if (field) {
      let hash = '#' + field.closest('.tab-pane').id;
      this.activateTab(hash);
      this.activatePane(hash);
    }
  }
}
